<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Configurações — Modelos de Documento: Criação e edição
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica o assistente de
        strong  9 etapas
        |  para
        strong  criar
        |  ou
        strong  editar
        |  um modelo em
        strong  Configurações → Modelos de Documento
        | .

      .toast.toast-primary
        | Exige
        strong  Sistema → Modelos de documento → Criar
        |  (novo) ou
        strong  Sistema → Modelos de documento → Alterar
        |  (edição). O botão
        strong  Logs
        |  na etapa Informações (somente edição) exige
        strong  Logs → Listar
        | .

      h5.h5 1. Abrir o assistente
      ol
        li Em
          strong  Configurações → Modelos de Documento
          | , clique em
          strong  +
          |  e escolha o tipo, ou use
          strong  Editar
          |  na linha do modelo.
        li O cabeçalho mostra
          strong  Novo Modelo de Documento
          |  ou
          strong  Editar Modelo de Documento
          | , com o tipo e a barra de etapas.
        li Use
          strong  Avançar
          |  ou clique em uma etapa na barra para navegar.

      h5.h5 2. Informações
      p
        | Preencha
        strong  Título
        | ,
        strong  Descrição
        |  e o interruptor
        strong  Ativo
        | .
      figure.manual-figure
        img(:src="imgInfo" alt="Etapa Informações do modelo de documento")
      ol
        li Na edição, o botão
          strong  Logs
          |  abre o histórico de auditoria do modelo.
        li Clique em
          strong  Avançar
          | .

      h5.h5 3. Parâmetros
      p Configure prazos, limites e comportamentos do documento.
      figure.manual-figure
        img(:src="imgParams" alt="Etapa Parâmetros do modelo de documento")
      ol
        li Informe
          strong  Prazo para vencimento do débito
          |  (dias),
          strong  Limite de autuações
          |  (vazio = sem limite),
          strong  Mínimo de fotos
          | ,
          strong  Prazo
          |  (regularizar em dias),
          strong  Pontuação
          |  e os dias para abrir OS-m de verificação após vencer o prazo.
        li Selecione
          strong  Débito tipo
          |  e
          strong  Situação na ciência
          |  (regra padrão, Notificado, Autuado ou Aguardando Regularizar).
        li Se necessário, preencha o
          strong  texto para implantar
          |  (observação do lançamento no tributário, até 255 caracteres).
        li Ajuste os interruptores:
          strong  Permite solicitar defesa
          | ,
          strong  Permite emitir com documentos em andamento
          | ,
          strong  Ciência automática
          | ,
          strong  Autua automaticamente
          | ,
          strong  Implantar automaticamente ao dar ciência
          | ,
          strong  Implantar ao autuar
          | ,
          strong  Vistoria pelo mesmo fiscal
          |  e
          strong  Bloqueia cadastro de fundo de vale
          | .
        li Clique em
          strong  Avançar
          | .

      h5.h5 4. Cálculo
      figure.manual-figure
        img(:src="imgCalculo" alt="Etapa Cálculo do modelo de documento")
      ol
        li Escolha a
          strong  Origem de cálculo
          | : Não informar, Área, Tamanho da testada, Determinado, Soma de irregularidades ou Grau de infração.
        li Se for
          strong  Área
          | , marque se deve usar a área do cadastro.
        li Para Área ou Testada, adicione
          strong  regras
          |  (Fixo, Multiplicador ou Mult. fração) com parâmetro inicial/final, valor e fração. A última faixa deve ir até o máximo (botão ∞).
        li Para
          strong  Grau de infração
          | , adicione graus com descrição e valor.
        li Clique em
          strong  Avançar
          | .

      h5.h5 5. Reincidência
      figure.manual-figure
        img(:src="imgReincidencia" alt="Etapa Reincidência do modelo de documento")
      ol
        li Informe o
          strong  Prazo para reincidência (dias)
          | . Se for 0, os demais campos ficam ocultos.
        li Preencha
          strong  Prazos para regularizar
          |  por ocorrência (1º, 2º…),
          strong  Quantidade limite
          | ,
          strong  Multiplicador
          |  (mín. 1),
          strong  Origem da base de cálculo
          |  e o interruptor
          strong  Permite desconto
          | .
        li Clique em
          strong  Avançar
          | .

      h5.h5 6. Assuntos
      figure.manual-figure
        img(:src="imgAssuntos" alt="Etapa Assuntos do modelo de documento")
      p
        | Associe assuntos de OS-m para vistorias (opcionais): verificar notificação,
        |  pedido de desconto, autuação, entrega de documento, notificação sem valor
        |  e pedido de prazo. Clique em
        strong  Avançar
        | .

      h5.h5 7. Irregularidades
      figure.manual-figure
        img(:src="imgIrregularidades" alt="Etapa Irregularidades do modelo de documento")
      ol
        li Clique em
          strong  Adicionar irregularidade
          | .
        li Informe
          strong  Descrição
          |  e, se houver,
          strong  Valor
          | . Confirme.
        li Arraste para ordenar; use
          strong  Editar
          |  ou
          strong  Remover
          |  conforme necessário.
        li Clique em
          strong  Avançar
          | .

      h5.h5 8. Integração
      figure.manual-figure
        img(:src="imgIntegracao" alt="Etapa Integração do modelo de documento")
      ol
        li Em
          strong  Atualizar Cadastro no Tributário?
          | , escolha se e como atualizar a situação no momento da ciência
          |  (Não atualizar, Normal, Alvará cassado, Baixado, Embargado etc.).
        li Clique em
          strong  Avançar
          | .

      h5.h5 9. Textos
      figure.manual-figure
        img(:src="imgTextos" alt="Etapa Textos do modelo de documento")
      ol
        li Clique em
          strong  Adicionar
          |  para criar blocos de texto do modelo.
        li Preencha
          strong  Título
          |  e
          strong  Descrição
          | ; confirme. Arraste para ordenar.
        li Clique em
          strong  Avançar
          | .

      h5.h5 10. Confirmar e salvar
      p
        | A última etapa resume todas as seções. Cada bloco tem link
        strong  Editar
        |  para voltar à etapa correspondente.
      figure.manual-figure
        img(:src="imgConfirmar" alt="Etapa Confirmar do modelo de documento")
      ol
        li Revise tipo, informações, parâmetros, cálculo, reincidência, assuntos,
          |  irregularidades, integração e textos.
        li Clique em
          strong  Salvar
          | . Você volta à listagem com mensagem de sucesso.

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgInfo: require("@/assets/manuais/34-config-modelos-doc-wizard-info.png"),
      imgParams: require("@/assets/manuais/34a-config-modelos-doc-wizard-params.png"),
      imgCalculo: require("@/assets/manuais/34c-config-modelos-doc-wizard-calculo.png"),
      imgReincidencia: require("@/assets/manuais/34d-config-modelos-doc-wizard-reincidencia.png"),
      imgAssuntos: require("@/assets/manuais/34e-config-modelos-doc-wizard-assuntos.png"),
      imgIrregularidades: require("@/assets/manuais/34f-config-modelos-doc-wizard-irregularidades.png"),
      imgIntegracao: require("@/assets/manuais/34g-config-modelos-doc-wizard-integracao.png"),
      imgTextos: require("@/assets/manuais/34h-config-modelos-doc-wizard-textos.png"),
      imgConfirmar: require("@/assets/manuais/34b-config-modelos-doc-wizard-confirmar.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
